export const showLoader = () => {
    const overlayingDiv: any = document.getElementById("global-overlay");
    if (overlayingDiv) overlayingDiv.style.display = "block";
  };
  
  export const hideLoader = () => {
    const overlayingDiv: any = document.getElementById("global-overlay");
    if (overlayingDiv) overlayingDiv.style.display = "none";
  };
  